<template>
  <v-row>
    <v-col cols="12">
      <v-sheet outlined>
        <v-data-table
          :headers="headers"
          :search="search"
          :items="items"
          :custom-filter="customFilter"
          fixed-header
          class="secondary row-height-50"
        >
          <!-- Actions -->
          <template #[`item.action`]="{ item }">
            <v-icon
              small
              class="mr-2"
              color="accent"
              @click="$emit('edit', item)"
            >
              mdi-pencil
            </v-icon>

            <!--<v-icon small color="red" @click="$emit('delete', item)">
              mdi-delete
            </v-icon>-->
          </template>

          <!-- Amount -->
          <template #[`item.amount`]="{ item }">
            {{ formatCurrency(item.amount) }}
          </template>

          <!-- Batch -->
          <template #[`item.batch`]="{ item }">
            {{ item.year }} - {{ item.batch }}
          </template>

          <!-- Enrollment End -->
          <template #[`item.enrollment_end`]="{ item }">
            {{ formatDate(item.enrollment_end) }}
          </template>

          <!-- Programs -->
          <template #[`item.program_id`]="{ item }">
            <div class="d-flex align-center flex-wrap">
              <span>
                {{ getDisplayText(item.program_id, "program") }}
              </span>

              <v-btn
                v-if="showMore(item.program_id, 'program')"
                x-small
                text
                color="primary"
                class="ml-1 px-1"
                @click="openDialog(item.program_id, 'Programs')"
              >
                +{{ item.program_id.length - 2 }} others
              </v-btn>

              <v-btn
                v-else-if="isAllSelected(item.program_id, 'program')"
                x-small
                text
                color="primary"
                class="ml- mt-1 px-1"
                @click="openDialog(item.program_id, 'Programs')"
              >
                View All
              </v-btn>
            </div>
          </template>

          <!-- Partners -->
          <template #[`item.partner_id`]="{ item }">
            <div class="d-flex align-center flex-wrap">
              <span>
                {{ getDisplayText(item.partner_id, "partner") }}
              </span>

              <v-btn
                v-if="showMore(item.partner_id, 'partner')"
                x-small
                text
                color="primary"
                class="ml-1 px-1"
                @click="openDialog(item.partner_id, 'Partners')"
              >
                +{{ item.partner_id.length - 2 }} others
              </v-btn>

              <v-btn
                v-else-if="isAllSelected(item.partner_id, 'partner')"
                x-small
                text
                color="primary"
                class="ml-1 px-1"
                @click="openDialog(item.partner_id, 'Partners')"
              >
                View All
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-sheet>
    </v-col>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="primary white--text">
          {{ dialogTitle }}

          <v-spacer></v-spacer>

          <v-btn icon dark @click="dialog = false">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <div class="d-flex flex-wrap" style="gap: 10px">
            <v-chip
              v-for="(item, index) in dialogItems"
              :key="index"
              small
              class="font-weight-medium"
            >
              {{ item }}
            </v-chip>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    search: {
      type: String,
      default: "",
    },

    programs: {
      type: Array,
      default: () => [],
    },

    partners: {
      type: Array,
      default: () => [],
    },

    getProgramName: {
      type: Function,
      required: true,
    },

    getPartnerName: {
      type: Function,
      required: true,
    },

    formatCurrency: {
      type: Function,
      required: true,
    },

    formatDate: {
      type: Function,
      required: true,
    },

    customFilter: {
      type: Function,
      required: true,
    },
  },

  emits: ["edit", "delete"],

  data() {
    return {
      dialog: false,
      dialogTitle: "",
      dialogItems: [],
    };
  },

  methods: {
    getNames(ids, type) {
      if (!Array.isArray(ids)) return [];

      if (type === "program") {
        return this.programs
          .filter((program) => ids.includes(program.id))
          .map((program) => {
            return (
              program.degree.short_name +
              (program.specialization ? ` - ${program.specialization}` : "")
            );
          });
      }

      return this.partners
        .filter((partner) => ids.includes(partner.id))
        .map((partner) => partner.name);
    },

    isAllSelected(ids, type) {
      if (!Array.isArray(ids)) return false;

      if (type === "program") {
        return ids.length === this.programs.length;
      }

      return ids.length === this.partners.length;
    },

    getDisplayText(ids, type) {
      if (!Array.isArray(ids) || !ids.length) {
        return "-";
      }

      if (this.isAllSelected(ids, type)) {
        return type === "program" ? "All Programs" : "All Partners";
      }

      const names = this.getNames(ids, type);

      return names.slice(0, 2).join(", ");
    },

    showMore(ids, type) {
        if(this.getDisplayText(ids, type) === "All Partners" || this.getDisplayText(ids, type) === "All Programs") return false
      return Array.isArray(ids) && ids.length > 2;
    },

    openDialog(ids, title) {
      this.dialogTitle = title;

      const type = title === "Programs" ? "program" : "partner";

      this.dialogItems = this.getNames(ids, type);

      this.dialog = true;
    },
  },
};
</script>

<style scoped>
.row-height-50 >>> tbody tr {
  height: 50px;
}

.secondary {
  background-color: #f5f5f5;
}
</style>
